import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Formik, Form, Field, ErrorMessage } from "formik";
import {
  errorMessageStyle,
  formInputPopUp,
} from "../../../ui-elements/formStyles/formStyle";
import { validationSchema } from "./validation/validationSchema";
import "./partnersModal.css";
import { becomeAPartner } from "../../../axios/api/partnersApi";
import {
  changePopUpStatus,
  setRequestStatus,
} from "../../../redux/slices/popUp/popUpSlice";
import { useDispatch } from "react-redux";
import { navigateTo } from "../../../utils/navigationUtils";
import { useNavigate } from "react-router-dom";
import "react-responsive-modal/styles.css";
import { Modal } from "react-responsive-modal";

const PartnersModal = ({ showModal, onClose }) => {
  const [isDesktop, setIsDesktop] = useState(window.innerWidth >= 1024);
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    const handleResize = () => setIsDesktop(window.innerWidth >= 1024);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleSubmit = async (values) => {
    const responseData = await becomeAPartner(values);
    dispatch(setRequestStatus(responseData));
    dispatch(changePopUpStatus(true));
    onClose();
  };

  const handleNavigate = () => {
    onClose();
    navigateTo(navigate, "/privacy-policy");
  };

  useEffect(() => {
    if (showModal) {
      setTimeout(() => {
        if (document.activeElement instanceof HTMLElement) {
          document.activeElement.blur();
        }
      }, 100);
    }
  }, [showModal]);

  return (
    <Modal
      open={showModal}
      onClose={onClose}
      center={isDesktop}
      classNames={{
        overlay: "partners-modal-overlay",
        modal: "partners-modal-custom",
      }}
      closeOnOverlayClick={true}
      focusTrapped={true}
      blockScroll={true}
      initialFocusRef={null}
    >
      {/* custom close icon  */}
      {/* <div className=" flex justify-end  px-5 mt-3 ">
        <MdOutlineClose
          className="text-gray-600 hover:text-a050 h-6 w-6 cursor-pointer"
          onClick={onClose}
        />
      </div> */}
      <div
        className="bg-white dark:bg-[#111] flex flex-col justify-start
       items-center p-5
       w-full sm:max-w-sm lg:max-w-[712px] lg:h-auto
        overflow-y-auto overflow-x-hidden
        "
      >
        <div className="max-w-[400px] sm:max-w-full">
          <div className="flex flex-col items-start justify-center w-full">
            <h1 className=" w-full text-black dark:text-white font-[500] text-[30px] text-center">
              {t("becomeAPartner2")}
            </h1>
            <span className=" w-full text-center prose-t12_regular text-a070 dark:text-[#d1d1d1]">
              {t("youCanReachUs")}
            </span>
          </div>
          <Formik
            initialValues={{
              companyName: "",
              category: "",
              email: "",
              phoneNumber: "",
              info: "",
            }}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
            validateOnMount={false}
            validateOnBlur={false}
          >
            <Form>
              {/* Company Name + Category */}
              <div className="mt-4 grid grid-cols-2 gap-4">
                <div className="flex flex-col">
                  <Field
                    type="text"
                    name="companyName"
                    placeholder={t("companyName")}
                    className={formInputPopUp}
                  />
                  <div className="min-h-[20px]">
                    <ErrorMessage
                      name="companyName"
                      component="div"
                      className={errorMessageStyle}
                    />
                  </div>
                </div>

                <div className="flex flex-col">
                  <Field
                    type="text"
                    name="category"
                    placeholder={t("serviceSegment")}
                    className={formInputPopUp}
                  />
                  <div className="min-h-[20px]">
                    <ErrorMessage
                      name="category"
                      component="div"
                      className={errorMessageStyle}
                    />
                  </div>
                </div>
              </div>

              {/* Email + Phone */}
              <div className="mt-4 grid grid-cols-2 gap-4">
                <div className="flex flex-col">
                  <Field
                    type="text"
                    name="email"
                    placeholder={t("yourEmail")}
                    className={formInputPopUp}
                  />
                  <div className="min-h-[20px]">
                    <ErrorMessage
                      name="email"
                      component="div"
                      className={errorMessageStyle}
                    />
                  </div>
                </div>

                <div className="flex flex-col">
                  <Field
                    type="text"
                    name="phoneNumber"
                    placeholder={t("phoneNumber")}
                    className={formInputPopUp}
                  />
                  <div className="min-h-[20px]">
                    <ErrorMessage
                      name="phoneNumber"
                      component="div"
                      className={errorMessageStyle}
                    />
                  </div>
                </div>
              </div>

              {/* Info textarea */}
              <div className="mb-5 md:mb-8 mt-4">
                <div className="flex flex-col w-full">
                  <Field
                    as="textarea"
                    name="info"
                    placeholder={t("additionalInformation")}
                    rows={4}
                    style={{ resize: "none" }}
                    className="bg-[#dadada] dark:bg-secondary_black shadow-md overflow-hidden px-4 py-3 ring-2 ring-gray-200 dark:ring-[#3a3a3a] hover:ring-primary dark:hover:ring-primary transition-all duration-300 text-[13px] md:prose-t16_regular focus:outline-none focus:ring-2 focus:ring-primary dark:focus:ring-primary rounded-[7px]"
                  />
                  <div className="min-h-[20px]">
                    <ErrorMessage
                      name="info"
                      component="div"
                      className={errorMessageStyle}
                    />
                  </div>
                </div>
              </div>

              {/* Submit Button */}
              <div className="mb-2.5 flex justify-center">
                <button
                  type="submit"
                  className="w-[300px] lg:w-[328px] h-[48px] bg-primary text-white prose-t16_regular hover:filter hover:brightness-90 rounded-3xl"
                >
                  {t("submit1")}
                </button>
              </div>
            </Form>
          </Formik>
          <div className="w-full flex justify-center items-center lg:justify-center">
            <span className="prose-t12_regular text-center text-[#5D5D5D] dark:text-[#d1d1d1]">
              {t("byContactingUsYou")}
              &nbsp;
              <a
                onClick={handleNavigate}
                target="_blank"
                rel="noopener noreferrer"
                className="prose-t12_bold cursor-pointer text-black dark:text-white hover:text-a070"
              >
                {t("privacyPolicy1")}
              </a>
            </span>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default PartnersModal;
